import {
  SET_AUTO_FILL,
  LOAD_AUTO_FILL } from '../../action-types/ui/setAutoFill';

export const STATE_KEY = 'setAutoFill';

export const setAutoFill = (state = false, action) => {
  switch (action.type) {
    case SET_AUTO_FILL:
      return action.setTrue;
    case LOAD_AUTO_FILL:
      return action.status;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/setAutoFill.js